<!-- Expanded State -->
<div class="active-trip-widget expanded" *ngIf="isExpanded">
  <div class="widget-header">
    <div class="header-actions">
      <!-- Pause OR Resume (same position) -->
      <button class="action-btn pause" *ngIf="!isPaused" (click)="onPause()">
        <img src="assets/trip/pause_icon.svg" /> Pause
      </button>

      <button class="action-btn resume" *ngIf="isPaused" (click)="onResume()">
        <img src="assets/trip/lines_in.svg" /> Resume
      </button>

      <!-- Lines In (ALWAYS visible) -->
      <button class="action-btn lines-in" (click)="onStop()">
        <img src="assets/trip/lines_in.svg" /> Lines In
      </button>

      <button class="minimize-btn" (click)="toggleExpand()">
        <img src="assets/trip/expand_icon.svg" />
      </button>
    </div>
  </div>

  <lib-snackbar [message]="snackbarMessage" [type]="snackbarType" [show]="showSnackbar" [duration]="4000"
    [autoClose]="true" [theme]="'light'" (onClose)="onSnackbarClose()"
    (onAutoClose)="onSnackbarAutoClose()"></lib-snackbar>

  <div class="widget-actions-grid">
    <div class="grid-item" (click)="onViewFullDetails()">
      <div class="icon-circle blue-light">
        <img src="assets/trip/tripdetails_icon.svg" class="icon" />
      </div>
      <span>View Full Trip Details</span>
    </div>
    <div class="grid-item" (click)="openVisibilitySettings.emit()">
      <div class="icon-circle gray-light">
        <img src="assets/trip/visibility_icon.svg" class="icon" />
      </div>
      <span>Visibility Settings</span>
    </div>
    <div class="grid-item" (click)="inviteMate.emit()">
      <div class="icon-circle blue-light">
        <img src="assets/trip/dockmates_icon.svg" class="icon" />
      </div>
      <span>Invite a Mate</span>
    </div>
    <div class="grid-item">
      <div class="icon-circle gray-light">
        <img src="assets/trip/databride_icon.svg" class="icon" />
      </div>
      <span>Data Bridge</span>
    </div>
    <div class="grid-item">
      <div class="icon-circle gray-light">
        <img src="assets/trip/wavepoint_icon.svg" class="icon" />
      </div>
      <span>Added Waypoints</span>
    </div>
  </div>
</div>